<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm6 class="pa-2">
        <v-card style="border-radius: 5px;" class="mb-3">
          <stat-card v-model="totalSuccess" :loading="isLoading">
            {{ $t('Conversations that GPT can answer') }}
          </stat-card>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pa-2">
        <v-card style="border-radius: 5px;">
          <stat-card v-model="totalFailed" :loading="isLoading">
            {{ $t("Conversations that GPT can't answer") }}
          </stat-card>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <h2 class="headline mt-0">{{ $t('Conversations Order') }}</h2>
      </v-flex>
      <v-flex xs12 class="pa-2">
        <v-card style="border-radius: 5px">
          <v-card-title>
            <p class="text-xs-right">{{ $t('Conversation') }}</p>
          </v-card-title>
          <div class style="position: relative;padding-bottom: 24px;">
            <dashboard-graph-loading v-if="isLoading"></dashboard-graph-loading>
            <template v-else>
              <template v-if="chartSeries && chartSeries.length > 0">
                <div style="max-width: 350px; margin: auto;">
                  <apexchart
                    ref="chartRef"
                    height="350"
                    type="pie"
                    :options="chartOption"
                    :series="chartSeries"
                    :key="timestamp"
                  ></apexchart>
                </div>
              </template>
              <template v-else>
                <div style="padding: 16px 0;display: flex; justify-content: center;">
                  {{ $t('No Data') }}
                </div>
              </template>
            </template>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import StatCard from '@/components/view/dashboard/StatCard.vue'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import { mapGetters } from 'vuex'
import gptApi from '@/api/gpt'
export default {
  props: {
    selectedDate: {
      type: [Object],
      default: () => {}
    },
    channelFilter: {
      type: [String],
      default: 'all'
    }
  },
  data() {
    return {
      isLoading: false,
      chartOption: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        legend: {
          show: false
        }
      },
      chartSeries: [],
      totalSuccess: 0,
      totalFailed: 0,
      timestamp: 0
    }
  },
  components: {
    StatCard,
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  watch: {
    selectedDate: {
      handler() {
        this.handleGetData()
      },
      deep: true
    },
    channelFilter() {
      this.handleGetData()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.handleResetState()
  },
  methods: {
    async handleGetData() {
      try {
        this.isLoading = true
        this.chartOption.labels = []
        this.chartSeries = []
        const response = await gptApi.getChatGPTAnalyticsConversation({
          pageId: this.selectedBot.pageid,
          params: {
            date_from: this.selectedDate.start,
            date_to: this.selectedDate.end,
            channel: this.channelFilter
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.totalSuccess = data.gpt_can_reply || 0
          this.totalFailed = data.gpt_can_not_reply || 0
          for (const [key, value] of Object.entries(data.data)) {
            this.chartOption.labels.push(key)
            this.chartSeries.push(value.count)
          }
          this.$nextTick(() => {
            if (this.$refs.chartRef) {
              this.timestamp = dayjs().unix()
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    handleResetState() {
      this.isLoading = true
      this.totalSuccess = 0
      this.totalFailed = 0
      this.timestamp = dayjs().unix()
      this.handleGetData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatgpt/GptChart.vue